var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock 1",
    clipPath: "url(#clip0_10223_15092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.96582 6.54981C5.96559 -0.116834 15.2991 -0.116832 15.2991 6.54963",
    stroke: "#949494",
    strokeWidth: 2.1375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.29867 6.79761H17.9653C18.7017 6.79761 19.2987 7.35726 19.2987 8.04761V17.7351C19.2987 18.4254 18.7017 18.9851 17.9653 18.9851H3.29867C2.56228 18.9851 1.96533 18.4254 1.96533 17.7351V8.04761C1.96533 7.35726 2.56228 6.79761 3.29867 6.79761Z",
    stroke: "#949494",
    strokeWidth: 2.1375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6329 10.8601H10.6329C9.83517 10.8601 9.18848 11.4664 9.18848 12.2143V13.5684C9.18848 14.3163 9.83517 14.9226 10.6329 14.9226H10.6329C11.4307 14.9226 12.0774 14.3163 12.0774 13.5684V12.2143C12.0774 11.4664 11.4307 10.8601 10.6329 10.8601Z",
    fill: "#949494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10223_15092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.75 0.299805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.bed5afa26bab92a15050a66808a85bff.svg";
export { ForwardRef as ReactComponent };